export enum AnalyticPilotEventTypes {
  Unknown = '',
  Login = 'Login',
  Logout = 'Logout',
  AppClosed = 'AppClosed',
  PopupPageLoaded = 'PopupPageLoaded',
  PopupPageUnloaded = 'PopupPageUnloaded',
  PageLoaded = 'PageLoaded',
  PageUnloaded = 'PageUnloaded',
  HelpRequested = 'HelpRequested',
  ButtonClicked = 'ButtonClicked',
  DocumentLoaded = 'DocumentLoaded',
  DocumentUnloaded = 'DocumentUnloaded',
  LibraryCCTWebCustomClickDocumentSearch = 'LibraryCCTWeb-Custom-ClickDocumentSearch',
  TrainingInfoCCTWebCustomClickDocumentSearch = 'TrainingInfoCCTWeb-Custom-ClickDocumentSearch',
  PrecheckInCustomStart = 'PrecheckIn_Custom_Start',
  PrecheckInCustomNext = 'PrecheckIn_Custom_Next',
  PrecheckInCustomReviewPrecheckIn = 'PrecheckIn_Custom_ReviewPrecheckIn',
  PrecheckInCustomSave = 'PrecheckIn_Custom_Save',
  PrecheckInCustomSubmitPrecheckIn = 'PrecheckIn_Custom_SubmitPrecheckIn',
  PrecheckInCustomDone = 'PrecheckIn_Custom_Done',
  PrecheckInCustomErrors = 'PrecheckIn_Custom_Errors',
  PrecheckInCustomEdit = 'PrecheckIn_Custom_Edit',
  PrecheckInCustomSubmitSurvey = 'PrecheckIn_Custom_SubmitSurvey',
  PrecheckInCustomAccessPass = 'PrecheckIn_Custom_AccessPass',
  PrecheckInCustomSaveImage = 'PrecheckIn_Custom_SaveImage',
  PrecheckInCustomBanner = 'PrecheckIn_Custom_Banner'
}
